// components
import GridPageAbstract from '../../GridPageAbstract';
import { BubbleBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class MerchantCategories extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'merchantCategory';
        this.Server = this.props.context.getState().server.merchantCategory;

        this.headerStartIcon = BubbleBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.searchFields = [
            'name',
        ];

        this.hiddenColumns = config?.hiddenColumns?.merchantCategory || [];

        this.Head = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Translatable'
            },
            {
                id: 'logoFilesId',
                sortField: 'logoFile.name',
                label: 'logoFiles',
                alignRight: false,
                cell: 'Upload',
                object: 'logoFile',
                disableInputFileType: true,
                fileType: 'merchant',
                fileParent: 'id',
                uploadType: 'single'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    customRetrieveData = async (list) => {
        const files = list.map((item) => item.logoFile);
        await this.preloadContextImages(files);
    };
}
